import { render, staticRenderFns } from "./HorizontalStackedBar.vue?vue&type=template&id=2a06ca26&scoped=true&"
import script from "./HorizontalStackedBar.vue?vue&type=script&lang=js&"
export * from "./HorizontalStackedBar.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalStackedBar.vue?vue&type=style&index=0&id=2a06ca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06ca26",
  null
  
)

export default component.exports